import React, { type ReactElement } from 'react'

function SelectSupplier (): ReactElement {
  return <div>Here will be the supplier selector</div>
}

export default SelectSupplier
